import { JourneyGroupType } from '@vista/omnichannel-components-domain';
export const getClassModifiersForJourneyGroupType = (journeyGroupType, filmMediaType) => ({
    nextJourney: journeyGroupType === JourneyGroupType.UpNext,
    foodAndDrinkJourney: journeyGroupType === JourneyGroupType.FoodAndDrink,
    filmMediaType
});
